import React, { useState, useEffect, useRef } from "react";
import { Row, Button, Col, Checkbox, Card, Input, Space, Typography, message, Badge, Modal, Select, Divider, Table } from "antd";
import Scrollbars from "react-custom-scrollbars";
import InfiniteScroll from "react-infinite-scroll-component";
import { v4 as uuidv4 } from "uuid";
import {
  CloseOutlined,
  LoadingOutlined,
  StopOutlined,
  SearchOutlined,
  PlusOutlined,
  MinusOutlined,
  ArrowRightOutlined,
  TransactionOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import Back from "../../../assets/images/backIcon.svg";
import CancelArrow from "../../../assets/images/cancelArrow.svg";
import Cash1 from "../../../assets/images/cash.svg";
import Card1 from "../../../assets/images/card.svg";
// import Credit from "../../../assets/images/creditCardIcon.svg";
import Credit from "../../../assets/images/creditIcon.svg";
import Loyality from "../../../assets/images/loyalityIcon.svg";
import Gift from "../../../assets/images/giftIcon.svg";
import giftVoucher from "../../../assets/images/giftVoucher.svg";
import creditNote from "../../../assets/images/creditNote.svg";
import UPI from "../../../assets/images/upiIcon.svg";
import qrCodeIcon from "../../../assets/images/qrCodeIcon.svg";
import paymentSuccess from "../../../assets/images/payment-success.svg";
import defaultImage from "../../../assets/images/no-image.svg";
import DiscountIcon from "../../../assets/images/discountperIcon.svg";
import printBill from "../../../assets/images/printbillIcon.svg";
import Offers from "../../../assets/images/promoTag.svg";
import DeleteImg from "../../../assets/images/delete1.svg";
import userIcon from "../../../assets/images/userId.svg";
import _ from "lodash";
import "./restaurantStyle.css";
import moment from "moment";
import db from "../../../database";
import { useTranslation } from "react-i18next";
import { getMultilingualText } from "../../../utility/getMultilingualText ";
import { useWindowDimensions } from "../../../lib/useViewport";
import PoleDisplay from "../../../lib/printer/poleDisplay";
import addNote from "../../../assets/images/addNote.svg";

const OrderListComponent = ({
  setSelectedProductInCart,
  selectedProductId,
  setSelectedProductId,
  manualDiscountRestaurant,
  cart,
  selectedTable,
  setSelectedTable,
  tillDataPaymentMethods,
  setSelectedPaymentMethod,
  selectedPaymentMethod,
  setIsCardPaymentFlag,
  processOrder,
  amount,
  onChangeAmount,
  paymentModalInputRef,
  setIsInputFocused,
  requestPayment,
  handleCashPayment,
  handleAmount,
  setNumb,
  setKeyValue,
  paymentVisible,
  setPaymentVisible,
  showOrderCompleteFlag,
  setShowOrderCompleteFlag,
  userPreferences,
  showProducts,
  setShowProducts,
  filteredPaymentMethods,
  getFilteredPaymentMethods,
  tableCards,
  setAmount,
  setTableCards,
  setCart,
  denaminationsKeyboard,
  setDenaminationsKeyboard,
  saleType,
  setSaleType,
  occupiedDataTablesData,
  setOcupiedTablesData,
  reservedTablesData,
  setReservedTablesData,
  tableList,
  setTableList,
  showSplitBill,
  setShowSplitBill,
  splitBillScreen,
  setSplitBillScreen,
  numSplits,
  setNumSplits,
  setDisplayCustomerSearch,
  deleteProduct,
  handleOrder,
  showAllItems,
  setShowAllItems,
  splitCarts,
  setSplitCarts,
  isSplitBill,
  setIsSplitBill,
  currentSplitIndex,
  setCurrentSplitIndex,
  recordState,
  setRecardState,
  removeSplit,
  setRemoveSplit,
  setMainTableData,
  setSelectedSaleType,
  selectedSaleType,
  setSelectedSaleTypeData
}) => {
  const { Text, Title } = Typography;
  const { width } = useWindowDimensions();
  const [orderTypeData, setOrderTypeData] = useState(0);
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const tillaccess = JSON.parse(tillData.tillAccess.userAccessController);
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const currenciesList = tillData?.tillAccess.csBunit.currencies;
  const [tableOrderData, setTableOrderData] = useState([]);
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const { t } = useTranslation();
  const themeJSON = posConfig?.themeJSON && posConfig?.themeJSON !== "N" && Object.keys(posConfig.themeJSON).length > 0 ? JSON.parse(posConfig.themeJSON)?.layout4 : {};
  const currenciesList1 = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
  const multilingual = process.env.REACT_APP_MULTILINGUAL === "true" && localStorage.getItem("selectedLanguage") !== "English";
  const [currenciesData, setCurrenciesData] = useState(tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => b.value - a.value) || []);
  const initialShowPayments = filteredPaymentMethods.length > 2 ? filteredPaymentMethods.slice(0, 2) : filteredPaymentMethods;
  const [showPayments, setShowPayments] = useState(initialShowPayments);
  const [isShowingAll, setIsShowingAll] = useState(false);
  const [OrderedItem, setOrderedItem] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(2);
  const { Option } = Select;
    const userData = JSON.parse(localStorage.getItem("userData"));
  const tillValue = JSON.parse(localStorage.getItem("tillValue"));

  const modulo = (a, b) => {
    return a - b * Math.floor(a / b);
  };

  const showMoreItems = () => {
    let sortedData = _.sortBy(filteredPaymentMethods, "sequenceNo");
    let totalItems = sortedData.length;

    let newStartIndex = startIndex + 2;
    let newEndIndex = newStartIndex + 2;
    if (newStartIndex >= totalItems) {
      newStartIndex = 0;
      newEndIndex = 2;
    } else if (newEndIndex > totalItems) {
      newEndIndex = totalItems;
    }

    const newData = sortedData.slice(newStartIndex, newEndIndex);

    setStartIndex(newStartIndex);
    setEndIndex(newEndIndex);
    setShowPayments(newData);
  };

  const showPreviousItems = () => {
    const initialPayments = _.sortBy(filteredPaymentMethods, "sequenceNo").slice(0, 2);
    setShowPayments(initialPayments);
    setStartIndex(2);
    setEndIndex(4);
    setIsShowingAll(false);
  };

  const handleDeletePayment = (payment) => {
    let paid = 0;
    Promise.all(
      cart.payments.map(async (pay) => {
        if (pay.name !== payment.name && payment.name.toLowerCase() !== "card") {
          paid = paid + parseFloat(pay.amount);
          return pay;
        } else if (payment.name.toLowerCase() === "card" && (payment.authorization ? pay.authorization !== payment.authorization : true)) {
          paid = paid + parseFloat(pay.amount);
          return pay;
        }
      })
    )
      .then((results) => {
        // Filter out undefined results (where payment name matched)
        cart.payments = results.filter((result) => result !== undefined);
        cart.paid = paid + (cart?.advancePayment || 0);
        setAmount(parseFloat((cart.total - cart.paid).toFixed(2)));
        if (payment?.name?.toLowerCase() === "cash") {
          cart.tenderedAmount = cart.tenderedAmount - payment.amount;
        }
        localStorage.setItem("cartObj", JSON.stringify(cart));
        setCart(cart);
      })
      .catch((error) => {
        // Handle errors
        console.error(error);
      });
  };

  // useEffect(() => {
  //   if (orderTypeData === 0) {
  //     db.tableData.toArray().then((response) => {
  //       let finalData = response.filter((data) => data.statusType === "OCU");
  //       setTableOrderData(finalData);
  //     });
  //   } else if (orderTypeData === 1) {
  //     setTableOrderData([]);
  //   } else if (orderTypeData === 2) {
  //     db.orders
  //       .where("isSynced")
  //       .equals(1)
  //       .toArray()
  //       .then((response) => {
  //         setTableOrderData(response);
  //       });
  //   }
  // }, [orderTypeData]);

  useEffect(() => {
    db.orders
      .where("isSynced")
      .equals(1)
      .toArray()
      .then((response) => {
        setTableOrderData(response);
      });
  }, [orderTypeData]);

  const printReceipt = () => {};

  useEffect(() => {
    db.orders
      .orderBy("orderTime")
      .reverse()
      .limit(1)
      .toArray()
      .then((response) => {
        setOrderedItem(response);
      });
  }, [cart]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.shiftKey && (e.key === "+" || e.key === "-")) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

    const getDefaultSaleType = async () => {
    const saleData = await db.posSaletypes.toArray();
    if (saleType === "DI") {
      const dineInSale = saleData.find((sale) => sale?.cwrSaletype?.value === "DI");
      if (dineInSale) {
        return dineInSale;
      }
    } else if (saleType === "TA") {
      const takeAwaySale = saleData.find((sale) => sale?.cwrSaletype?.value === "TA");
      if (takeAwaySale) {
        return takeAwaySale;
      }
  }else{
  const defaultSale = saleData.find((sale) => sale?.cwrSaletype?.isdefault === "Y");
    if (defaultSale) {
      return defaultSale;
    }
  }
  
  };
  return (
    <>
      {showOrderCompleteFlag ? (
        <div style={{ width: "100%", height: "100vh", padding: "2vh 1vw" }}>
          <Row gutter={[16]}>
            <Col
              span={12}
              style={{
                width: "100%",
                height: "96vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20vh 6vw 20vh 5vw",
                flexDirection: "column",
                fontSize: "1vw",
              }}
            >
              <div
                style={{
                  fontSize: "2em",
                  paddingBottom: "4vh",
                  fontWeight: 600,
                  color: "#0F0718",
                }}
              >
                {getMultilingualText("")} <img src={paymentSuccess} style={{ height: "4rem" }} />
              </div>
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Order No")}
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {OrderedItem[0]?.documentno}
                </Text>
              </Space>
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Payment Method")}
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {/* {OrderedItem[0]?.payments[0]?.name} */}
                  {OrderedItem[0]?.payments.map((payment, index) => (
                    <span key={index}>
                      {payment.name}
                      {index < OrderedItem[0]?.payments.length - 1 && ", "}
                    </span>
                  ))}
                </Text>
              </Space>
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Total Items")}
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {OrderedItem[0]?.totalQty}
                </Text>
              </Space>
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Subtotal")}
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {(OrderedItem[0]?.total - OrderedItem[0]?.tax).toFixed(2)}
                </Text>
              </Space>
              {/* <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  Discount Sales
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  -4
                </Text>
              </Space> */}
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Total Sales Tax")}
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 400,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {typeof OrderedItem[0]?.tax === "number" && OrderedItem[0].tax % 1 !== 0 ? parseFloat(OrderedItem[0].tax.toFixed(2)) : OrderedItem[0]?.tax}
                </Text>
              </Space>
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 600,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Total Amount")}
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 600,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {OrderedItem[0]?.total}
                  {/* {parseFloat(OrderedItem[0]?.total - OrderedItem[0]?.discount).toFixed(2)} */}
                </Text>
              </Space>
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 600,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Amount Paid")}
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 600,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
               {OrderedItem[0]?.payments.reduce((sum, p) => 
              sum + parseFloat(
                p.name.toLowerCase() === "cash" ? (OrderedItem[0]?.tenderedAmount || p.amount) : (p.amount || 0)
              ), 0).toFixed(2)}
                </Text>
              </Space>
              <Space
                style={{
                  width: "100%",
                  justifyContent: "space-between",
                  paddingTop: "2vh",
                }}
              >
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 600,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Change")}
                </Text>
                <Text
                  style={{
                    fontSize: "1.5em",
                    fontWeight: 600,
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                > 
                
  {OrderedItem[0]?.payments.some((p) => p.name.toLowerCase() === "cash")
      ? parseFloat(
          (OrderedItem[0]?.tenderedAmount || 0) -
            (OrderedItem[0]?.payments.find((p) => p.name.toLowerCase() === "cash")?.amount || 0)
        ).toFixed(2)
      : (0).toFixed(2)}

                </Text>
              </Space>
            </Col>
            <Col
              span={12}
              style={{
                width: "100%",
                height: "96vh",
                backgroundColor: "#fff",
                borderRadius: "15px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1vw",
              }}
            >
              <Text
                style={{
                  color: "#0F0718",
                  fontSize: "1.75em",
                  paddingBottom: "8vh",
                  fontWeight: 500,
                }}
              >
                How would you like your receipt ?{multilingual && <div style={{ display: "block" }}>{t("How would you like your receipt ?")}</div>}
              </Text>

              <Space direction="vertical" size="large">
                <Button
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#2F3856",
                    height: "7.5vh",
                    color: "#fff",
                    fontSize: "1em",
                    fontWeight: 500,
                    width: "23vw",
                  }}
                  onClick={printReceipt()}
                >
                  {getMultilingualText("Print Receipt")}
                </Button>

                {splitCarts.length > 0 ? (
                  <Button
                    style={{
                      borderRadius: "10px",
                      backgroundColor: "#fff",
                      border: "1px solid #92909880",
                      height: "7.5vh",
                      color: "#2F3856",
                      fontSize: "1em",
                      fontWeight: 500,
                      width: "23vw",
                    }}
                    onClick={() => {
                      setShowOrderCompleteFlag(false);
                      setPaymentVisible(false);
                    }}
                  >
                    Other Splits
                  </Button>
                ) : (
                  <Button
                    style={{
                      borderRadius: "10px",
                      backgroundColor: "#fff",
                      height: "7.5vh",
                      color: "#0F0718",
                      fontWeight: 500,
                      fontSize: "1em",
                      width: "23vw",
                    }}
                    onClick={async () => {
                        const defaultSaleType = await getDefaultSaleType();
                         setSelectedSaleType(defaultSaleType.cwrSaletype.name);
        setSelectedSaleTypeData(defaultSaleType);
                        const cartData = {
                           items: [],
                           couponInput: [],
                           total: 0,
                           tax: 0,
                           discount: 0,
                           paid: 0,
                           change: 0,
                           totalQty: 0,
                           roundOff: 0,
                           payments: [],
                           redemptionPoints: 0,
                           accumulationPoints: 0,
                           creditAmount: 0,
                           sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
                           referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
                           giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                           couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                           customer: defaultSaleType.customer?.b2cCustomerId ? defaultSaleType.customer : tillData.tillAccess.csBunit.b2cCustomer,
                           salesRepId: null,
                           cardPaymentData: {},
                           documentno: `${tillData?.tillAccess?.cwrTill?.prefix}${parseFloat(localStorage.getItem("documentSequence")) + 1}`,
                           userName: userData.user,
                           tillName: tillValue.name,
                           subTotal: 0,
                           itemsSummery: {},
                           amountInWords: "",
                           groupedItemsByTaxRate: {},
                           serviceCharge: 0,
                           tip: 0,
                           deiveryCharge: 0,
                           packingCharge: 0,
                         };
    setCart(cartData);
    localStorage.setItem("cartObj", JSON.stringify(cartData));
                      setSplitBillScreen(false);
                      setSplitCarts([]);
                      localStorage.setItem("dineIn", "Y");
                      setKeyValue("0");
                      setShowOrderCompleteFlag(false);
                      setPaymentVisible(false);
                      setShowProducts(false);
                      const cart = JSON.parse(localStorage.getItem("cartObj"));
                      if (saleType === "TA") {
                        localStorage.setItem("dineIn", "N");
                        setKeyValue("2");
                      } else if (saleType === "DI") {
                        setKeyValue("0");
                        const updatedTableData = await db.tableData.toArray();
                        setTableCards(updatedTableData);
                        const ocuTables = updatedTableData.filter((table) => table.statusType === "OCU");
                        setOcupiedTablesData(ocuTables);
                        const resTables = updatedTableData.filter((table) => table.statusType === "RES");
                        setReservedTablesData(resTables);
                        let tempData = [];
                        await db.tableData.toArray().then((fetched) => {
                          tempData.push(...fetched);
                        });
                        setTableList(tempData);
                      } else {
                        setIsCardPaymentFlag(false);
                        setKeyValue("1");
                      }
                    }}
                  >
                    {getMultilingualText("New Order")}
                  </Button>
                )}

                {/* <Button
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#fff",
                    border: "1px solid #92909880",
                    height: "7.5vh",
                    color: "#2F3856",
                    fontSize: "1em",
                    fontWeight: 500,
                    width: "23vw",
                  }}
                  onClick={() => {
                    setShowOrderCompleteFlag(false);
                    setPaymentVisible(false);

                    if (isSplitBill) {
                      const updatedSplits = [...splitCarts];
                      updatedSplits.splice(currentSplitIndex, 1);
                      if (updatedSplits.length > 0) {
                        const regeneratedSplits = updatedSplits.map((split, index) => {
                          const sOrderID = uuidv4().replace(/-/g, "").toUpperCase();
                          return {
                            ...split,
                            payments: [],
                            isSplit: "Y",
                            sOrderID,
                            referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
                            giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                            couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                          };
                        });
                        setSplitCarts(regeneratedSplits);
                        setCurrentSplitIndex(0);
                        setCart(regeneratedSplits[0]);
                        setSplitBillScreen(true);
                      } else {
                        setIsSplitBill(false);
                        setSplitCarts([]);
                        setCurrentSplitIndex(0);
                        setKeyValue("0");
                      }
                    }
                  }}
                >
                  Other Splits
                </Button> */}

                {/* <Button
                  style={{
                    borderRadius: "10px",
                    backgroundColor: "#fff",
                    height: "7.5vh",
                    color: "#0F0718",
                    fontWeight: 500,
                    fontSize: "1em",
                    width: "23vw",
                  }}
                  onClick={async () => {
                    localStorage.setItem("dineIn", "Y");
                    setKeyValue("0");
                    setShowOrderCompleteFlag(false);
                    setPaymentVisible(false);
                    setShowProducts(false);
                    const cart = JSON.parse(localStorage.getItem("cartObj"));
                    if (saleType === "TA") {
                      localStorage.setItem("dineIn", "N");
                      setKeyValue("2");
                    } else if (saleType === "DI") {
                      setSplitBillScreen(false);
                      setKeyValue("0");
                      const updatedTableData = await db.tableData.toArray();
                      setTableCards(updatedTableData);
                      const ocuTables = updatedTableData.filter((table) => table.statusType === "OCU");
                      setOcupiedTablesData(ocuTables);
                      const resTables = updatedTableData.filter((table) => table.statusType === "RES");
                      setReservedTablesData(resTables);
                      let tempData = [];
                      await db.tableData.toArray().then((fetched) => {
                        tempData.push(...fetched);
                      });
                      setTableList(tempData);
                    } else {
                      setIsCardPaymentFlag(false);
                      setKeyValue("1");
                    }
                  }}
                >
                  {getMultilingualText("New Order")}
                </Button> */}
              </Space>
            </Col>
          </Row>
        </div>
      ) : (
        <div style={{ display: "flex" }}>
          <div
            style={{
              width: cart.items.length > 0 ? "69%" : "100%",
              height: "100vh",
            }}
          >
            {paymentVisible ? (
              <div>
                <Row style={{ padding: "2vh 1.5vw 0 1.5vw", fontSize: "1vw" }}>
                  <Col span={24}>
                    <p
                      style={{
                        fontWeight: 500,
                        paddingLeft: "3px",
                        fontSize: "1.25em",
                        color: "#0F0718",
                      }}
                    >
                      <img
                        src={Back}
                        style={{
                          height: "4vh",
                          cursor: "pointer",
                          paddingBottom: "0.1em",
                        }}
                        onClick={() => {
                          if (cart.paid > 0) {
                            message.warning("Delete the applied payment method to continue.");
                            return;
                          }
                          setPaymentVisible(false);
                          setSelectedPayment(false);
                          setSelectedPaymentMethod({});
                        }}
                      />{" "}
                      Order Checkout
                    </p>
                  </Col>
                </Row>
                <Row style={{ textAlign: "center", fontSize: "1vw" }}>
                  <Col
                    span={24}
                    style={{
                      fontSize: "1.5em",
                      color: "#0F0718",
                      fontWeight: 500,
                    }}
                  >
                    {getMultilingualText("Amount To Pay")} {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                    {(cart.total - cart.paid).toFixed(2)}
                    {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                  </Col>
                  <Col span={5}></Col>
                  <Col span={14}>
                    <Row justify="center" style={{ padding: "5% 1% 0 3.5%", height: "18.5vh" }} gutter={5}>
                      {_.sortBy(showPayments, "sequenceNo").map((pm, ind) => {
                        if (
                          (posConfig.loyaltyApplicable === "N" && pm.name === "Loyalty") ||
                          (!cart?.customer?.loyaltyLevel?.cwrLoyaltyLevelId && pm.name === "Loyalty") ||
                          (!cart?.customer?.iscredit && pm.name === "Credit") ||
                          pm.name.toLowerCase() === "cafe tips"
                        ) {
                          return null;
                        }
                        return (
                          <Col span={8} key={pm.finPaymentmethodId}>
                            <button
                              onClick={() => {
                                if (cart.items.length > 0) {
                                  // paymentModalInputRef?.current?.select();
                                  // paymentModalInputRef?.current?.focus();
                                  // setNumb(0);
                                  setSelectedPayment(true);
                                  let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails")) || {
                                    orderStartTime: "",
                                    orderEndTime: "",
                                    paymentStartTime: "",
                                  };
                                  if (orderTimeDetails.paymentStartTime === "") {
                                    orderTimeDetails = {
                                      ...orderTimeDetails,
                                      paymentStartTime: moment(new Date()).format(userPreferences.dateTimeFormat),
                                    };
                                    localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
                                  }
                                  if (pm.name.toLowerCase() === "card" && !pm.integratedPayment && posConfig.enablePaymentData === "Y") {
                                    setIsCardPaymentFlag(true);
                                  }
                                  if (!amount || amount === "" || amount === "0") {
                                    const remainingBalance = (parseFloat(Math.abs(cart.total)) - parseFloat(cart.paid)).toFixed(2);
                                    setAmount(remainingBalance);
                                  }
                                  setSelectedPaymentMethod(pm);
                                }
                              }}
                              id={`sm-payment-${pm.name.toLowerCase()}`}
                              // ref={ind === 0 ? paymentCardRef : null}
                              style={{
                                backgroundColor: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#2F3856" : "#fff",
                                border: "1px solid #fff",
                                borderRadius: "7px",
                                height: "16vh",
                                width: "7.5vw",
                                cursor: "pointer",
                              }}
                              tabIndex={0}
                              onKeyPress={(e) => (e.charCode === 13 ? setSelectedPaymentMethod(pm) : null)}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexDirection: "row",
                                  position: "relative",
                                  fontSize: "1vw",
                                }}
                              >
                                {/* {pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? (
                                  <img src={ticSelect} style={{ top: "-2vh", right: "0", height: "2.1vh", position: "absolute" }} />
                                ) : null} */}
                                <span
                                  className="payment"
                                  style={{
                                    color: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#fff" : "#0F0718",
                                    fontSize: "1.5em",
                                  }}
                                >
                                  {pm.name.toLowerCase() === "cash" ? (
                                    <>
                                      {/* {currenciesList[0]
                                        ? currenciesList[0].currSymbol
                                        : ""} */}
                                      <img
                                        src={Cash1}
                                        style={{
                                          height: "3vh",
                                          marginTop: "-4vh",
                                          filter: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "invert(1)" : "invert(0)",
                                        }}
                                        // color={pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#fff" : "#0F0718"}
                                      />
                                      <p
                                        style={{
                                          position: "absolute",
                                          bottom: "-7.5vh",
                                          left: "25%",
                                        }}
                                      >
                                        {pm.name}
                                      </p>
                                    </>
                                  ) : pm.name.toLowerCase() === "card" ? (
                                    <>
                                      {/* <img
                                        src={Back}
                                        style={{ height: "2.5vh" }}
                                        color={
                                          pm.finPaymentmethodId ===
                                          selectedPaymentMethod.finPaymentmethodId
                                            ? "#fff"
                                            : "#0F0718"
                                        }
                                      /> */}
                                      <img
                                        src={Card1}
                                        style={{
                                          height: "3.5vh",
                                          marginTop: "-4vh",
                                          filter: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "invert(1)" : "invert(0)",
                                        }}
                                        // color={pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#fff" : "#0F0718"}
                                      />
                                      <p
                                        style={{
                                          position: "absolute",
                                          bottom: "-7.5vh",
                                          left: "25%",
                                        }}
                                      >
                                        {pm.name}
                                      </p>
                                    </>
                                  ) : pm.name.toLowerCase() === "upi" ? (
                                    <>
                                      <img
                                        // src={Back}
                                        src={qrCodeIcon}
                                        style={{
                                          height: "3.5vh",
                                          marginTop: "-4vh",
                                          filter: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "invert(1)" : "invert(0)",
                                        }}
                                        // color={pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#fff" : "#0F0718"}
                                      />
                                      <p
                                        style={{
                                          position: "absolute",
                                          bottom: "-6.5vh",
                                          left: "30%",
                                        }}
                                      >
                                        {pm.name}
                                      </p>
                                    </>
                                  ) : pm.name.toLowerCase() === "credit" ? (
                                    <>
                                      <img
                                        src={Credit}
                                        style={{
                                          height: "3vh",
                                          marginTop: "-4vh",
                                          filter: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "invert(1)" : "invert(0)",
                                        }}
                                      />
                                      <p
                                        style={{
                                          position: "absolute",
                                          bottom: "-6.5vh",
                                          left: "15%",
                                        }}
                                      >
                                        {pm.name}
                                      </p>
                                    </>
                                  ) : pm.name.toLowerCase() === "loyalty" ? (
                                    <>
                                      <img
                                        src={Loyality}
                                        style={{
                                          height: "2.5vh",
                                          left: "0.5em",
                                          filter: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "invert(1)" : "invert(0)",
                                        }}
                                        // color={pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#fff" : "#0F0718"}
                                      />
                                      <p
                                        style={{
                                          position: "absolute",
                                          bottom: "-7.5vh",
                                          left: "25%",
                                        }}
                                      >
                                        {pm.name}
                                      </p>
                                    </>
                                  ) : pm.name.toLowerCase() === "gift card" ? (
                                    <>
                                      <img
                                        src={Gift}
                                        style={{
                                          height: "2.5vh",
                                          marginBottom: "0.2em",
                                          filter: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "invert(1)" : "invert(0)",
                                        }}
                                        // color={pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#fff" : "#0F0718"}
                                      />
                                      <p
                                        style={{
                                          position: "absolute",
                                          bottom: "-7.5vh",
                                          left: "25%",
                                        }}
                                      >
                                        {pm.name}
                                      </p>
                                    </>
                                  ) : pm.name.toLowerCase() === "gift voucher" ? (
                                    <>
                                      <img
                                        src={giftVoucher}
                                        style={{
                                          height: "2.5vh",
                                          marginBottom: "0.2em",
                                          filter: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "invert(1)" : "invert(0)",
                                        }}
                                        // color={pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#fff" : "#0F0718"}
                                      />
                                      <p
                                        style={{
                                          position: "absolute",
                                          bottom: "-7.5vh",
                                          left: "25%",
                                        }}
                                      >
                                        {pm.name}
                                      </p>
                                    </>
                                  ) : pm.name.toLowerCase() === "credit note" ? (
                                    <>
                                      <img
                                        src={creditNote}
                                        style={{ height: "2.5vh", filter: pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "invert(1)" : "invert(0)" }}
                                        // color={pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? "#fff" : "#0F0718"}
                                      />
                                      <p
                                        style={{
                                          position: "absolute",
                                          bottom: "-7.5vh",
                                          left: "25%",
                                        }}
                                      >
                                        {pm.name}
                                      </p>
                                    </>
                                  ) : (
                                    // ""
                                    <p
                                      style={{
                                        left: "25%",
                                        textAlign: "center",
                                        margin: 0,
                                      }}
                                    >
                                      {pm.name}
                                    </p>
                                  )}
                                </span>
                              </div>
                            </button>
                          </Col>
                        );
                      })}
                      {cart.layAway === "Y" && posConfig.advanceLayaway === "Y" ? (
                        <Col
                          span={8}
                          onClick={() => {
                            setShowOrderCompleteFlag(true);
                            processOrder("layaway");
                          }}
                        >
                          <button
                            style={{
                              backgroundColor: "#046307C2",
                              border: "1px solid #fff",
                              borderRadius: "7px",
                              height: "8.6vh",
                              width: "100%",
                              cursor: "pointer",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "row",
                              }}
                            >
                              {/* <CheckOutlined style={{ fontSize: "3vh", color: "#fff" }} /> */}
                            </div>
                          </button>
                        </Col>
                      ) : null}

                      {filteredPaymentMethods.length > 2 && (
                        <Col span={8}>
                          <button
                            // onClick={isShowingAll ? showPreviousItems : showMoreItems}
                            onClick={() => {
                              setSelectedPaymentMethod({});
                              isShowingAll ? showPreviousItems() : showMoreItems();
                            }}
                            style={{
                              backgroundColor: "#2F3856",
                              border: "1px solid #fff",
                              borderRadius: "7px",
                              height: "16vh",
                              width: "7.5vw",
                              cursor: "pointer",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "row",
                              }}
                            >
                              <img style={{ height: "2.5vh", left: "0.5em" }} color={"#fff"} />
                              <span className="payment" style={{ color: "#fff", marginLeft: "0.25em" }}>
                                ...
                              </span>
                            </div>
                          </button>
                        </Col>
                      )}
                    </Row>

                    <Row style={{ margin: "0 0 0 0 ", paddingTop: "10%" }}>
                      <Input
                        className="productSearch sm-payment-search totalInput"
                        style={{
                          borderRadius: "0.5vw",
                          height: "7.3vh",
                          margin: "0 1% 2.7% 3.5%",
                          borderRadius: "5px",
                          textAlign: "right",
                          fontWeight: "500",
                          fontSize: "2.5em",
                          borderColor: "#fff",
                          color: "#2F3856",
                        }}
                        // prefix={<span style={{ color: "#0F0718", fontWeight: "600" }}>Amount Tendered</span>}
                        value={amount}
                        id="sm-total-amount-input"
                        onChange={onChangeAmount}
                        placeholder="Enter Amount"
                        ref={paymentModalInputRef}
                        onFocus={() => {
                          setIsInputFocused(true);
                        }}
                        onBlur={() => {
                          setIsInputFocused(false);
                        }}
                        readOnly={cart.items.length > 0 ? false : true}
                        disabled={tillData.tillAccess.cwrTill.layAway === "Y" && tillData.tillAccess.cwrTill.payNow === "N" ? true : false}
                        onPressEnter={() => {
                          if (!selectedPayment && paymentVisible) {
                            message.warning("Please select a payment method before proceeding.");
                            return;
                          }
                          const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                          const denominationsValue = filtredCurrencies[0]?.value || 1;
                          const scale = 100; // For 2 decimal places
                          const scaledDividend = Math.round(amount * scale); // 1040
                          const scaledDivisor = Math.round(denominationsValue * scale); // 20

                          const scaledRemainder = scaledDividend % scaledDivisor;
                          const remainder = scaledRemainder / scale;
                          const isGiftCardOrLoyalty =
                            selectedPaymentMethod?.name?.toLowerCase() !== "loyalty" &&
                            selectedPaymentMethod?.name?.toLowerCase() !== "voucher" &&
                            selectedPaymentMethod?.name?.toLowerCase() !== "gift card";
                          if (isGiftCardOrLoyalty && paymentVisible) {
                            if (parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                              // if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && parseFloat(amount) % 0.25 !== 0) {
                              if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && remainder !== 0) {
                                // message.warning("Payment must be a multiple of 0.25");
                                message.warning(`Payment must be a multiple of ${denominationsValue}`);
                              } else {
                                setNumb(0);
                                if (cart.paid + parseFloat(amount) > cart.total.toFixed(2) && selectedPaymentMethod?.name?.toLowerCase() !== "cash") {
                                  message.warn("Overpayment not allowed with non-cash methods. Please adjust the amount!");
                                  return;
                                }
                                if (parseFloat(Math.abs(cart.total)) <= parseFloat(cart.paid) + Math.abs(amount)) {
                                  // requestPayment(selectedPaymentMethod, amount);
                                  setShowOrderCompleteFlag(true);
                                }
                                requestPayment(selectedPaymentMethod, amount);
                                setSelectedPayment(false);
                              }
                            } else {
                              setShowOrderCompleteFlag(true);
                              processOrder();
                            }
                          } else if (paymentVisible === false) {
                            setPaymentVisible(true);
                          }
                        }}
                      />
                    </Row>
                    {denaminationsKeyboard && selectedPaymentMethod?.name?.toLowerCase() === "cash" ? (
                      <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
                        <Col span={18}>
                          <Row gutter={[8, 6]} style={{ display: "flex", flexDirection: "row" }}>
                            {currenciesData
                              .sort((a, b) => b.seqNo - a.seqNo)
                              .slice(showAll ? 11 : 0, showAll ? currenciesData.length : 11)
                              .map((currency, index) => (
                                <Col span={8} key={index}>
                                  <button
                                    id={`sm-amount-button${index + 1}`}
                                    className="amt-dial-btn-restaurant"
                                    onClick={() => handleCashPayment(currency.value)}
                                    disabled={currency.value === 999999}
                                    style={{
                                      color: currency.value !== 999999 ? "#0f0718" : "transparent",
                                    }}
                                  >
                                    {currency.value}
                                  </button>
                                </Col>
                              ))}
                            {currenciesData.length > 12 && (
                              <Col span={8}>
                                <button id="sm-amount-buttonMore" className="amt-dial-btn-restaurant" onClick={() => setShowAll(!showAll)}>
                                  {showAll ? "Back" : "More..."}
                                </button>
                              </Col>
                            )}
                          </Row>
                        </Col>
                        <Col span={6}>
                          <Row style={{ padding: "0 0 7% 7%" }}>
                            <button className="amt-dial-btn-restaurant" id="sm-amount-buttonRemove" onClick={() => handleAmount("x")}>
                              <img src={CancelArrow} alt="back space" width={width <= 1024 ? 20 : 25} height={width <= 1024 ? 15 : 15} />
                            </button>
                          </Row>
                          <Row style={{ padding: "0 0 7% 7%" }}>
                            <button id="sm-amount-buttonClear" className="amt-dial-btn-restaurant" onClick={() => setDenaminationsKeyboard(!denaminationsKeyboard)}>
                              1,2,3...
                            </button>
                          </Row>
                          <Row style={{ padding: "0 0 0 7%" }}>
                            <button
                              id="sm-amount-buttonEnter"
                              className="amt-dial-btn-restaurant-ent"
                              onClick={() => {
                                if (!selectedPayment && paymentVisible) {
                                  message.warning("Please select a payment method before proceeding.");
                                  return;
                                }
                                const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                                const denominationsValue = filtredCurrencies[0]?.value || 1;
                                const scale = 100; // For 2 decimal places
                                const scaledDividend = Math.round(amount * scale); // 1040
                                const scaledDivisor = Math.round(denominationsValue * scale); // 20

                                const scaledRemainder = scaledDividend % scaledDivisor;
                                const remainder = scaledRemainder / scale;
                                const isGiftCardOrLoyalty =
                                  selectedPaymentMethod?.name?.toLowerCase() !== "loyalty" &&
                                  selectedPaymentMethod?.name?.toLowerCase() !== "voucher" &&
                                  selectedPaymentMethod?.name?.toLowerCase() !== "gift card";
                                if (isGiftCardOrLoyalty && paymentVisible) {
                                  if (parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                                    // if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && parseFloat(amount) % 0.25 !== 0) {
                                    if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && remainder !== 0) {
                                      // message.warning("Payment must be a multiple of 0.25");
                                      message.warning(`Payment must be a multiple of ${denominationsValue}`);
                                    } else {
                                      setNumb(0);
                                      if (cart.paid + parseFloat(amount) > cart.total.toFixed(2) && selectedPaymentMethod?.name?.toLowerCase() !== "cash") {
                                        message.warn("Overpayment not allowed with non-cash methods. Please adjust the amount!");
                                        return;
                                      }
                                      if (parseFloat(Math.abs(cart.total)) <= parseFloat(cart.paid) + Math.abs(amount)) {
                                        // requestPayment(selectedPaymentMethod, amount);
                                        setShowOrderCompleteFlag(true);
                                      }
                                      requestPayment(selectedPaymentMethod, amount);
                                      setSelectedPayment(false);
                                    }
                                  } else {
                                    setShowOrderCompleteFlag(true);
                                    processOrder();
                                  }
                                } else if (paymentVisible === false) {
                                  setPaymentVisible(true);
                                }
                              }}
                            >
                              Enter
                            </button>
                          </Row>
                        </Col>
                      </Row>
                    ) : (
                      <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
                        <Col span={6}>
                          <button id="sm-amount-button1" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("1")}>
                            1
                          </button>
                        </Col>
                        <Col span={6}>
                          <button id="sm-amount-button2" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("2")}>
                            2
                          </button>
                        </Col>
                        <Col span={6}>
                          <button id="sm-amount-button3" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("3")}>
                            3
                          </button>
                        </Col>
                        <Col span={6}>
                          <button
                            className="amt-dial-btn-restaurant"
                            style={{ background: themeJSON?.keyBoardColor }}
                            id="sm-amount-buttonRemove"
                            onClick={() => handleAmount("x")}
                          >
                            <img src={CancelArrow} alt="back space" width={25} height={15} />
                          </button>
                        </Col>
                        <Col span={6}>
                          <button id="sm-amount-button4" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("4")}>
                            4
                          </button>
                        </Col>
                        <Col span={6}>
                          <button id="sm-amount-button5" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("5")}>
                            5
                          </button>
                        </Col>
                        <Col span={6}>
                          <button id="sm-amount-button6" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("6")}>
                            6
                          </button>
                        </Col>
                        <Col span={6}>
                          <button
                            id="sm-amount-buttonClear"
                            className="amt-dial-btn-restaurant"
                            style={{ background: themeJSON?.keyBoardColor }}
                            onClick={() => setDenaminationsKeyboard(!denaminationsKeyboard)}
                          >
                            1,2,3...
                          </button>
                        </Col>

                        <Col span={18}>
                          <Row gutter={[8, 6]}>
                            <Col span={8}>
                              <button id="sm-amount-button7" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("7")}>
                                7
                              </button>
                            </Col>
                            <Col span={8}>
                              <button id="sm-amount-button8" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("8")}>
                                8
                              </button>
                            </Col>
                            <Col span={8}>
                              <button id="sm-amount-button0" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("9")}>
                                9
                              </button>
                            </Col>
                            <Col span={8}>
                              <button id="sm-amount-button0" className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("0")}>
                                0
                              </button>
                            </Col>
                            <Col span={8}>
                              <button
                                id="sm-amount-button00"
                                className="amt-dial-btn-restaurant"
                                style={{ background: themeJSON?.keyBoardColor }}
                                onClick={() => handleAmount("00")}
                              >
                                00
                              </button>
                            </Col>
                            <Col span={8}>
                              <button id="sm-amount-button." className="amt-dial-btn-restaurant" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount(".")}>
                                .
                              </button>
                            </Col>
                          </Row>
                        </Col>

                        <Col span={6}>
                          <button
                            id="sm-amount-buttonEnter"
                            className="amt-dial-btn-restaurant-ent"
                            style={{ background: themeJSON?.keyBoardColor }}
                            onClick={() => {
                              if (!selectedPayment && paymentVisible) {
                                message.warning("Please select a payment method before proceeding.");
                                return;
                              }
                              const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                              const denominationsValue = filtredCurrencies[0]?.value || 1;
                              const scale = 100; // For 2 decimal places
                              const scaledDividend = Math.round(amount * scale); // 1040
                              const scaledDivisor = Math.round(denominationsValue * scale); // 20

                              const scaledRemainder = scaledDividend % scaledDivisor;
                              const remainder = scaledRemainder / scale;
                              const isGiftCardOrLoyalty =
                                selectedPaymentMethod?.name?.toLowerCase() !== "loyalty" &&
                                selectedPaymentMethod?.name?.toLowerCase() !== "voucher" &&
                                selectedPaymentMethod?.name?.toLowerCase() !== "gift card";
                              if (isGiftCardOrLoyalty && paymentVisible) {
                                if (parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                                  // if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && parseFloat(amount) % 0.25 !== 0) {
                                  if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && remainder !== 0) {
                                    // message.warning("Payment must be a multiple of 0.25");
                                    message.warning(`Payment must be a multiple of ${denominationsValue}`);
                                  } else {
                                    setNumb(0);
                                    if (cart.paid + parseFloat(amount) > cart.total.toFixed(2) && selectedPaymentMethod?.name?.toLowerCase() !== "cash") {
                                      message.warn("Overpayment not allowed with non-cash methods. Please adjust the amount!");
                                      return;
                                    }
                                    if (parseFloat(Math.abs(cart.total)) <= parseFloat(cart.paid) + Math.abs(amount)) {
                                      // requestPayment(selectedPaymentMethod, amount);
                                      setShowOrderCompleteFlag(true);
                                    }
                                    requestPayment(selectedPaymentMethod, amount);
                                  }
                                } else {
                                  setShowOrderCompleteFlag(true);
                                  processOrder();
                                }
                              } else if (paymentVisible === false) {
                                setPaymentVisible(true);
                              }
                            }}
                          >
                            Enter
                          </button>
                        </Col>
                      </Row>
                    )}
                  </Col>
                  <Col span={5}></Col>
                </Row>
              </div>
            ) : (
              <div>
                <Row>
                  <Col span={10} style={{ margin: "1.5vh 0 0 2vw", fontSize: "1.5em", color: "#0F0718", fontWeight: 600 }}>
                    Orders History
                  </Col>
                  {/* <Col span={10} className="floor-buttons">
                    <Button
                      onClick={() => {
                        setOrderTypeData(0);
                      }}
                      className={`floor-button ${orderTypeData === 0 ? "selected" : ""}`}
                    >
                      {getMultilingualText("In progress")}
                    </Button>
                    <Button
                      onClick={() => {
                        setOrderTypeData(1);
                      }}
                      className={`floor-button ${orderTypeData === 1 ? "selected" : ""}`}
                    >
                      {getMultilingualText("Ready")}
                    </Button>
                    <Button
                      onClick={() => {
                        setOrderTypeData(2);
                      }}
                      className={`floor-button ${orderTypeData === 2 ? "selected" : ""}`}
                    >
                      {getMultilingualText("Completed")}
                    </Button>
                  </Col> */}
                </Row>
                <Scrollbars autoHide style={{ height: "90vh" }}>
                  <InfiniteScroll
                    dataLength={tableOrderData.length}
                    hasMore={true}
                    endMessage={
                      <p className="center">
                        <b>Yay! you have seen it all</b>
                      </p>
                    }
                    style={{ overflowX: "hidden" }}
                  >
                    <Row
                      style={{
                        marginTop: "2vh",
                        paddingLeft: "1vw",
                        paddingRight: "1vw",
                      }}
                    >
                     {[...tableOrderData]
                      .sort((a, b) => {
                        const aDoc = a.documentno?.replace(/\D/g, "") || "0";
                        const bDoc = b.documentno?.replace(/\D/g, "") || "0";
                        return parseInt(aDoc) - parseInt(bDoc);
                      })
                      .map((orderData) => {
                        return (
                          <Col span={cart.items.length > 0 ? 12 : 8} style={{ padding: "1vh 0.6vw" }}>
                            <Badge.Ribbon text={orderData.dineIn === "Y" ? "Dine-In" : "Take-Away"} color="">
                              <Card
                                style={{
                                  backgroundColor: "#fff",
                                  padding: "1vh 0.7vw",
                                  borderRadius: "10px",
                                  height: "16vh",
                                  fontSize: "1vw",
                                  cursor: "pointer",
                                }}
                              >
                                <Space
                                  style={{
                                    width: "100%",
                                    justifyContent: "space-between",
                                    paddingLeft: "7px",
                                    paddingRight: "7px",
                                  }}
                                >
                                  <Text
                                    style={{
                                      fontSize: "1.25em",
                                      fontWeight: 600,
                                      color: "#0F0718",
                                      fontFamily: "Inter",
                                    }}
                                  >
                                    {getMultilingualText("Order")} {orderData?.documentno || null}
                                  </Text>
                                  <Text
                                    style={{
                                      fontSize: "1.25em",
                                      fontWeight: 500,
                                      color: "#929098",
                                      fontFamily: "Inter",
                                    }}
                                  >
                                    {/* {orderData?.orderTime?.split(" ")[1] || ""} */}
                                  </Text>
                                </Space>
                                <Space
                                  style={{
                                    width: "100%",
                                    justifyContent: "space-between",
                                    paddingLeft: "7px",
                                    paddingRight: "7px",
                                  }}
                                >
                                  <Text
                                    style={{
                                      fontSize: "1em",
                                      fontWeight: 500,
                                      color: "#0F0718",
                                      fontFamily: "Inter",
                                    }}
                                  >
                                    Order {orderData?.customer?.name || null}
                                  </Text>
                                  <Text
                                    style={{
                                      fontSize: "1em",
                                      fontWeight: 500,
                                      color: "#929098",
                                      fontFamily: "Inter",
                                    }}
                                  >
                                    {orderData?.orderTime?.split(" ")[1] || ""}
                                  </Text>
                                </Space>
                                {/* <Space
                                style={{
                                  width: "100%",
                                  justifyContent: "space-between",
                                  paddingLeft: "7px",
                                  paddingRight: "7px",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: "1em",
                                    fontWeight: 500,
                                    color: "#0F0718",
                                    fontFamily: "Inter",
                                  }}
                                >
                                  {orderData.name}
                                </Text>
                                <Text
                                  style={{
                                    fontSize: "1em",
                                    fontWeight: 500,
                                    color: "#929098",
                                    fontFamily: "Inter",
                                  }}
                                ></Text>
                              </Space> */}
                                <Space
                                  style={{
                                    width: "100%",
                                    justifyContent: "space-between",
                                    paddingLeft: "7px",
                                    paddingRight: "7px",
                                  }}
                                >
                                  <Text
                                    style={{
                                      fontSize: "1em",
                                      fontWeight: 500,
                                      color: "#0F0718",
                                      fontFamily: "Inter",
                                    }}
                                  >
                                    {t("Ordered Items")}: {orderData?.items?.length || 0}
                                  </Text>
                                  <Text
                                    style={{
                                      fontSize: "1.25em",
                                      fontWeight: 600,
                                      color: "#0F0718",
                                      fontFamily: "Inter",
                                    }}
                                  >
                                    {t("Amount")}: {orderData?.totalAmount || orderData?.total || 0}
                                  </Text>
                                </Space>
                              </Card>
                            </Badge.Ribbon>
                          </Col>
                        );
                      })}
                    </Row>
                  </InfiniteScroll>
                </Scrollbars>
              </div>
            )}
          </div>
          {cart.items.length > 0 ? (
            <div
              style={{
                background: "#fff",
                height: "100vh",
                width: "31%",
                position: "relative",
                fontSize: "1vw",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "2vh 1vw 0 1vw",
                }}
              >
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: "1.5em",
                    color: "#0F0718",
                    fontFamily: "Inter",
                  }}
                >
                  {getMultilingualText("Order Details")}
                </span>
                <span style={{ fontWeight: 500, fontSize: "1em", color: "#929098" }}>{moment(cart.orderTime).format(userPreferences.dateFormat)}</span>
              </div>
              {saleType === "DI" && (
                <p
                  style={{
                    padding: "0 1vw",
                    fontSize: "1em",
                    color: "#0F0718",
                    fontWeight: 500,
                    marginBottom: "5px",
                  }}
                >
                  {selectedTable?.name}
                </p>
              )}
              <button
                style={{
                  marginLeft: "0.9vw",
                  color: "#0F0718",
                  backgroundColor: "#fff",
                  border: "1px solid #92909880",
                  fontSize: "0.85em",
                  borderRadius: "4px",
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0.2vh 0.5vw",
                  cursor: "pointer",
                }}
              >
                <img src={userIcon} style={{ height: 15, width: "1.5vw", marginRight: "0.2vw" }} />
                {cart?.customer?.name}
              </button>

              <hr style={{ color: "#929098", width: "93%" }} />
              <Scrollbars
                autoHide
                // style={{ height: "58vh" }}
                style={{
                  // height: "46vh"
                  height: localStorage.getItem("dineIn") === "N" ? "46vh" : "42vh",
                }}
              >
                <InfiniteScroll
                  dataLength={cart.items.length}
                  hasMore={true}
                  endMessage={
                    <p className="center">
                      <b>Yay! you have seen it all</b>
                    </p>
                  }
                  style={{ overflowX: "hidden" }}
                >
                  {cart.items.map((item) => {
                    return (
                      <div style={{ padding: "12px" }}>
                        <div
                          style={{ fontSize: "1vw", backgroundColor: selectedProductId === item.lineId ? "#f0f0f0" : "transparent" }}
                          onClick={() => {
                            setSelectedProductId(item.lineId);
                            setSelectedProductInCart(item);
                          }}
                        >
                          <Row>
                            <Col span={5}>
                              <img
                                src={item.imageurl || defaultImage}
                                alt={item.name}
                                style={{
                                  // height: "8vh",
                                  height: item.description ? "12vh" : "10vh",
                                  width: "5.5vw",
                                  objectFit: "cover",
                                  borderRadius: "7px",
                                }}
                              />
                            </Col>
                            <Col
                              span={16}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                paddingLeft: "0.5vw",
                              }}
                            >
                              <Text
                                style={{
                                  fontSize: "1em",
                                  color: "#0F0718",
                                  fontWeight: 500,
                                }}
                              >
                                {item.name}
                              </Text>
                              <Text
                                style={{
                                  fontSize: "0.8em",
                                  color: "#929098",
                                  fontWeight: 400,
                                }}
                              >
                                {item.description}
                              </Text>
                              <Text>
                                {" "}
                                {item?.selectedAddons?.map((subitem) => (
                                  <Row>
                                    <Col span={14}>
                                      <p style={{ fontSize: "0.8em", color: "#929098", marginBottom: 0 }}>+ {subitem.name}</p>
                                    </Col>
                                  </Row>
                                ))}
                              </Text>
                              <Text
                                style={{
                                  fontWeight: 600,
                                  fontSize: "1.25em",
                                  color: "#0F0718",
                                }}
                              >
                                {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
                                {item.nettotal.toFixed(item?.isQtyDesimal)}
                                {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol} ` : ""}
                              </Text>
                            </Col>
                            <Col
                              span={2}
                              style={{
                                textAlign: "center",
                                color: "#0F0718",
                                fontWeight: 500,
                                fontSize: "1.1em",
                              }}
                            >
                              X {item.weight}
                            </Col>
                            <span
                              style={{
                                background: Math.abs(item.discount) > 0 ? "#F8C519" : "",
                                borderRadius: "3px",
                                padding: "0.25vw",
                                display: item.discountName ? "" : "none",
                                fontSize: "0.7em",
                                marginTop: "1vh",
                              }}
                            >
                              {Math.abs(item.discount) > 0 ? item.discountName ? <img src={Offers} alt="" width={12} height={12} style={{ marginTop: "-2px" }} /> : "" : ""}{" "}
                              {Math.abs(item.discount) > 0 ? item.discountName || "" : ""}{" "}
                            </span>
                          </Row>
                        </div>
                      </div>
                    );
                  })}
                </InfiniteScroll>
              </Scrollbars>
              <div
                style={{
                  padding: "1vh 0.6vw",
                  position: "absolute",
                  bottom: "1vh",
                  width: "100%",
                }}
              >
                <Scrollbars style={{ height: "18vh" }}>
  <Space
    direction="vertical"
    style={{
      width: "100%",
      background: "#F3F4F9",
      padding: "1vh 0.5vw",
      borderRadius: "10px",
      rowGap: "4px",
    }}
  >
    {/* ───────────── Sub‑total ───────────── */}
    <Space style={{ width: "100%", justifyContent: "space-between" }}>
      <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
        {getMultilingualText("Subtotal")}
      </Text>
      <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
        {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
        {(cart.total - cart.tax).toFixed(pricePrecision)}
        {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
      </Text>
    </Space>

    {/* ───────────── Discount ───────────── */}
    <Space style={{ width: "100%", justifyContent: "space-between" }}>
      <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
        {getMultilingualText("Discount Sales")}
      </Text>
      <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
        {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
        {parseFloat(cart.discount || 0).toFixed(pricePrecision)}
        {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
      </Text>
    </Space>

    {/* ───────────── Sales tax ───────────── */}
    <Space style={{ width: "100%", justifyContent: "space-between" }}>
      <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
        {getMultilingualText("Total Sales Tax")}
      </Text>
      <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
        {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
        {parseFloat(cart.tax || 0).toFixed(pricePrecision)}
        {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
      </Text>
    </Space>

    {/* ───────────── NEW: Service charge ───────────── */}
    {parseFloat(cart.serviceCharge || 0) > 0 && (
      <Space style={{ width: "100%", justifyContent: "space-between" }}>
        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
          {getMultilingualText("Service Charge")}
        </Text>
        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
          {parseFloat(cart.serviceCharge).toFixed(pricePrecision)}
          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
        </Text>
      </Space>
    )}

    {/* ───────────── NEW: Tip ───────────── */}
    {parseFloat(cart.tip || 0) > 0 && (
      <Space style={{ width: "100%", justifyContent: "space-between" }}>
        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
          {getMultilingualText("Tip")}
        </Text>
        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
          {parseFloat(cart.tip).toFixed(pricePrecision)}
          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
        </Text>
      </Space>
    )}

    {/* ───────────── NEW: Delivery charge ───────────── */}
    {parseFloat(cart.deiveryCharge || cart.deliveryCharge || 0) > 0 && (   /* keep typo for back‑compat */
      <Space style={{ width: "100%", justifyContent: "space-between" }}>
        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
          {getMultilingualText("Delivery Charge")}
        </Text>
        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
          {parseFloat(cart.deiveryCharge || cart.deliveryCharge).toFixed(pricePrecision)}
          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
        </Text>
      </Space>
    )}

    {/* ───────────── NEW: Packing charge ───────────── */}
    {parseFloat(cart.packingCharge || 0) > 0 && (
      <Space style={{ width: "100%", justifyContent: "space-between" }}>
        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
          {getMultilingualText("Packing Charge")}
        </Text>
        <Text style={{ fontSize: "1em", fontWeight: 500, color: "#929098", fontFamily: "Inter" }}>
          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
          {parseFloat(cart.packingCharge).toFixed(pricePrecision)}
          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
        </Text>
      </Space>
    )}

    {/* ───────────── Grand total ───────────── */}
    <Space style={{ width: "100%", justifyContent: "space-between", marginTop: "2px" }}>
      <Text style={{ fontSize: "1.1em", fontWeight: 600, color: "#0F0718", fontFamily: "Inter" }}>
        {getMultilingualText("Total Amount")}
      </Text>
      <Text style={{ fontSize: "1.1em", fontWeight: 600, color: "#0F0718", fontFamily: "Inter" }}>
        {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
        {(
          Math.floor(
            (parseFloat(cart.total) +
              parseFloat(cart.serviceCharge || 0) +
              parseFloat(cart.tip || 0) +
              parseFloat(cart.deiveryCharge || cart.deliveryCharge || 0) +
              parseFloat(cart.packingCharge || 0)) *
              100
          ) / 100
        ).toFixed(pricePrecision)}
        {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
      </Text>
    </Space>

    {/* ───────────── Existing payment list ───────────── */}
    <Space direction="vertical" style={{ width: "100%", padding: 0 }} size={3}>
      {cart.payments.map((item, index) => (
        <div key={index} style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
          <Text style={{ fontSize: "1.1em", fontWeight: 400, color: "#008000", fontFamily: "Inter" }}>
            {item.name.toLowerCase() === "card" ? `${item.name}${item.authorization ? ` - ${item.authorization}` : ""}` : item.name}{" "}
            {getMultilingualText("Payment")}
          </Text>
          <Text style={{ fontSize: "1.1em", fontWeight: 400, color: "#008000", fontFamily: "Inter" }}>
            {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
            &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)}{" "}
            {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}&nbsp;&nbsp;
            <img
              src={DeleteImg}
              onClick={() => handleDeletePayment(item)}
              style={{ height: "15px", width: "15px", cursor: "pointer" }}
            />
          </Text>
        </div>
      ))}
    </Space>
  </Space>
</Scrollbars>

                <div>
                  <Space direction="horizontal" style={{ paddingTop: "1.5vh", fontSize: "1vw" }}>
                    <Button
                      style={{
                        width: "13.5vw",
                        border: "1px solid rgba(146, 144, 152, 0.5)",
                        borderRadius: "10px",
                        color: "#2F3856",
                        height: "5.5vh",
                        fontSize: "1em",
                        fontWeight: "500",
                      }}
                      onClick={manualDiscountRestaurant}
                    >
                      <img src={DiscountIcon} style={{ paddingRight: "0.3rem", height: "2.5vh" }} />
                      <span>Add Discount</span>
                    </Button>

                    <Button
                      style={{
                        width: "13.5vw",
                        borderRadius: "10px",
                        color: "#2F3856",
                        height: "5.5vh",
                        fontSize: "1em",
                        fontWeight: "500",
                      }}
                    >
                      <img src={printBill} style={{ paddingRight: "0.3rem", height: "2.5vh" }} />
                      <span>Print Bill</span>
                    </Button>
                  </Space>
                </div>
                <div>
                  <Space direction="horizontal" style={{ paddingTop: "2vh" }}>
                    <Button
  onClick={async () => {
    if (!selectedPayment && paymentVisible) {
      message.warning("Please select a payment method before proceeding.");
      return;
    }
    const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
    const denominationsValue = filtredCurrencies[0]?.value || 1;
    const scale = 100; // For 2 decimal places
    const scaledDividend = Math.round(amount * scale); // 1040
    const scaledDivisor = Math.round(denominationsValue * scale); // 20

    const scaledRemainder = scaledDividend % scaledDivisor;
    const remainder = scaledRemainder / scale;
    const isGiftCardOrLoyalty =
      selectedPaymentMethod?.name?.toLowerCase() !== "loyalty" &&
      selectedPaymentMethod?.name?.toLowerCase() !== "voucher" &&
      selectedPaymentMethod?.name?.toLowerCase() !== "gift card";
    if (isGiftCardOrLoyalty && paymentVisible) {
      if (parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
        if (selectedPaymentMethod?.name?.toLowerCase() === "cash" && remainder !== 0) {
          message.warning(`Payment must be a multiple of ${denominationsValue}`);
        } else {
          setNumb(0);
          if (cart.paid + parseFloat(amount) > cart.total.toFixed(2) && selectedPaymentMethod?.name?.toLowerCase() !== "cash") {
            message.warn("Overpayment not allowed with non-cash methods. Please adjust the amount!");
            return;
          }
          if (parseFloat(Math.abs(cart.total)) <= parseFloat(cart.paid) + Math.abs(amount)) {
            setShowOrderCompleteFlag(true);
          }
          requestPayment(selectedPaymentMethod, amount);
          setSelectedPayment(false);
          if(localStorage.getItem("dineIn") === "Y"){
            const updatedTableData = await db.tableData.toArray();
            setTableCards(updatedTableData);
            setMainTableData(updatedTableData);
            const updatedOccupiedData = updatedTableData.filter((table) => table?.statusType === "OCU");
            setOcupiedTablesData(updatedOccupiedData);
            const updatedReservedData = updatedTableData.filter((table) => table.statusType === "RES");
            setReservedTablesData(updatedReservedData);
          }
          if (isSplitBill) {
            const updatedSplits = splitCarts.filter((split) => split.splitNo !== removeSplit.splitNo);
            if (updatedSplits.length > 0) {
              const regeneratedSplits = updatedSplits.map((split, index) => {
                const sOrderID = uuidv4().replace(/-/g, "").toUpperCase();
                return {
                  ...split,
                  payments: [],
                  isSplit: "Y",
                  sOrderID,
                  referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
                  giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                  couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
                };
              });
              setSplitCarts(regeneratedSplits);
              setCurrentSplitIndex(0);
              setCart(regeneratedSplits[0]);
              setSplitBillScreen(true);
            } else {
              setIsSplitBill(false);
              setSplitCarts([]);
              setCurrentSplitIndex(0);
              setKeyValue("0");
            }

            localStorage.setItem("tableName", JSON.stringify(recordState));
          }
        }
      } else {
        setShowOrderCompleteFlag(true);
        processOrder();
      }
    } else if (paymentVisible === false) {
      setPaymentVisible(true);
    }
  }}
  style={{
    width: "27.8vw",
    borderRadius: "10px",
    backgroundColor: paymentVisible ? (selectedPayment ? "#2F3856" : "#92909880") : "#2F3856",
    color: "#fff",
    height: "6vh",
    fontSize: "1em",
    fontWeight: 500,
  }}
>
  {paymentVisible ? `${getMultilingualText("Add Payment")}` : `${getMultilingualText("Pay Bill")}`}
</Button>
                  </Space>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </>
  );
};

export default OrderListComponent;
